<div class="loading" *ngIf="loading$  | async">
    <div class="loading-spinner"></div>
</div>